import script from "./modelrunner.vue?vue&type=script&setup=true&lang=js"
export * from "./modelrunner.vue?vue&type=script&setup=true&lang=js"

import "./modelrunner.vue?vue&type=style&index=0&id=b708e2a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b708e2a4"]])

export default __exports__